<template>
  <div>
    <div class="home-header">
      <img  class="home-header-img" src="../../assets/img/logo.png" alt="" />
      <!-- <div style="position: absolute;margin-top:-5px;margin-left:30px;font-size: 25px;">|</div> -->
      <!-- <div style="position: absolute;margin-left:38px;margin-top: 5px;"><img class="home-header-img" src="../../assets/img/ruyi.png" alt="" /></div> -->
      <p style="margin-left: 35px;display:flex;font-size:large;position: absolute;">合益</p>

      <div class="home-header-right">
        <el-menu router
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
        <el-menu-item><router-link replace to="/bwIndex">首页</router-link></el-menu-item>  
          <el-menu-item><router-link replace to="/ruzhu">开放平台</router-link></el-menu-item>
          <el-menu-item><router-link replace to="/zixun">资讯</router-link></el-menu-item>
          <el-menu-item><router-link replace to="/houtai">商家后台</router-link></el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  onLoad(){
      handleSelect(0, keyPath);
  },
  methods: {
      handleSelect(key, keyPath) {
          console.log(key, keyPath);
      },
  },
  //计算属性
  computed: {
    curActive() {
      
    },
  },
};
</script>

<style scoped>
.home-header {
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #e6e6e6;
  position: fixed;
  top: 0px;
  padding-left: 0px;
  padding-right: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  z-index: 9;
}

.home-header-img{
  width: 30px;
  height: 30px;
  left:200px;
}

.el-menu-demo {
  height: 80px;
  z-index: 9999;
}
</style>